import React from 'react';

import { IUser } from '../../../layouts/MainLayout/slice/types';

export function useAdminDashboardUserDisplay() {
  const initials = React.useCallback((nameOrEmail?: string) => {
    const v = (nameOrEmail ?? '').trim();
    return (v[0] ?? '?').toUpperCase();
  }, []);

  const formatUserTitle = React.useCallback((user: IUser | null | undefined) => {
    if (!user) return '—';
    return user.name || user.email || user._id;
  }, []);

  return { initials, formatUserTitle };
}

